import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {Validators} from "@angular/forms";
import {IFontFormat} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {SceneMimeTypes} from "../mime-constants";
import {ToastrService} from "ngx-toastr";
import {StoreSelectorsService} from "../../../../services";
import * as _ from "lodash";

@Component({
    selector: 'app-scene-block-label',
    templateUrl: './block-json-item.component.html',
    styleUrls: ['./block-json-item.component.scss']
})
export class BlockJsonItemComponent extends BlockBaseComponent {
    fieldType: string;
    maintainAspectRatio = false;
    dateModel = 'MM/DD/YY';
    stringJSPipeArgs = {humanize: []};

    constructor(private translocoService: TranslocoService,
                private toastr: ToastrService,
                public override storeSelector: StoreSelectorsService,
                public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override preInit() {
        super.preInit();
    }

    override initRegisterDynamic() {
        switch (this.mimeTypeLong) {
            case SceneMimeTypes.Spreadsheet: {
                this.uiConfigInit = [
                    {
                        type: "input",
                        label: this.translocoService.translate('general.row', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        name: "fieldName",
                        storePath: 'Data[0].XmlItem[0].$.fieldName',
                        value: '1',
                        min: '1',
                        max: '99999',
                        validations: [
                            {
                                name: "required",
                                validator: Validators.required,
                                message: "value required"
                            },
                            {
                                name: "pattern",
                                validator: Validators.pattern("^[0-9]+$"),
                                message: "Accept only numbers"
                            }
                        ]
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.column', {}, this.translocoService.getActiveLang()),
                        inputType: "number",
                        name: "fieldName2",
                        value: '1',
                        min: '1',
                        max: '99999',
                        validations: [
                            {
                                name: "required",
                                validator: Validators.required,
                                message: "value required"
                            },
                            {
                                name: "pattern",
                                validator: Validators.pattern("^[0-9]+$"),
                                message: "Accept only numbers"
                            }
                        ]
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        options: ["text"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.GoogleDrive: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionsLabel: 'file',
                                optionValue: 'id',
                                optionType: 'object'
                            },
                            {
                                optionsLabel: 'name',
                                optionValue: 'title',
                                optionType: 'text'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.DropBox: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'file',
                                optionValue: 'file',
                                optionType: 'object'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Flickr: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'thumbnail',
                                optionValue: 'thumbnail',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'image',
                                optionValue: 'large',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.IFTTT: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'value 1',
                                optionValue: 'value1',
                                optionType: ''
                            },
                            {
                                optionsLabel: 'value 2',
                                optionValue: 'value2',
                                optionType: ''
                            },
                            {
                                optionsLabel: 'value 3',
                                optionValue: 'value3',
                                optionType: ''
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case 'Stocks':
            case SceneMimeTypes.Stocks: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        ignoreMissingValue: true,
                        name: "field",
                        value: "",
                        options: [
                            {
                                optionsLabel: 'Symbol',
                                optionValue: 'Symbol',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Last Trade',
                                optionValue: 'LastTrade',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Change',
                                optionValue: 'Change',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Trade Time',
                                optionValue: 'TradeTime',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Trade Date',
                                optionValue: 'TradeDate',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Percentage',
                                optionValue: 'Percentage',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Open',
                                optionValue: 'Open',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Max',
                                optionValue: 'Max',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Min',
                                optionValue: 'Min',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Volume',
                                optionValue: 'Volume',
                                optionType: 'text'
                            },

                        ],
                        storePath: 'Data[0].StockItem[0].$.field'
                    },
                    {
                        type: "input",
                        label: this.translocoService.translate('general.negativeColor', {}, this.translocoService.getActiveLang()),
                        name: "negativeColor",
                        inputType: "color",
                        value: "",
                        storePath: 'Data[0].StockItem[0].$.negativeColor'
                    }
                ];
                break;
            }
            case 'XML':
            case SceneMimeTypes.XML: {
                this.uiConfigInit = [
                    {
                        type: "input",
                        label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        inputType: "text",
                        value: "fieldName",
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.fieldType', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "fieldType",
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                    // ,
                    // {
                    //     type: "input",
                    //     value: '',
                    //     label: this.translocoService.translate('general.url', {}, this.translocoService.getActiveLang()),
                    //     inputType: "text",
                    //     name: "urlBase",
                    //     storePath: 'Data[0].XmlItem[0].$.urlBase'
                    // }
                ];
                break;
            }

            case 'CustomRss':
            case SceneMimeTypes.CustomRss: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "field",
                        value: "",
                        options: [
                            {
                                optionsLabel: 'description',
                                optionValue: 'description',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'title',
                                optionValue: 'title',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'resource',
                                optionValue: 'resource',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].RssItem[0].$.field'
                    }
                ];
                break;
            }
            case 'Catalog':
            case SceneMimeTypes.Catalog: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "field",
                        value: "",
                        options: [
                            {
                                optionsLabel: 'name',
                                optionValue: 'ItemName',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Item info 0',
                                optionValue: 'ItemInfo0',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Item info 1',
                                optionValue: 'ItemInfo1',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Item info 2',
                                optionValue: 'ItemInfo2',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'Item info 3',
                                optionValue: 'ItemInfo3',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'resource',
                                optionValue: 'ItemResourceMain',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].CatalogItem[0].$.field'
                    }
                ];
                break;
            }
            case SceneMimeTypes.X: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'post',
                                optionValue: 'post',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'media0',
                                optionValue: 'media.0.url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'media1',
                                optionValue: 'media.1.url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'media2',
                                optionValue: 'media.2.url',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }

            case SceneMimeTypes.Twitter: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'user name',
                                optionValue: 'name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'screen name',
                                optionValue: 'screen_name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'text',
                                optionValue: 'text',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created at',
                                optionValue: 'created_at',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'profile image url',
                                optionValue: 'profile_image_url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'profile background image url',
                                optionValue: 'profile_background_image_url',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.GoogleBusiness: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'user name',
                                optionValue: 'name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'screen name',
                                optionValue: 'screen_name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'text',
                                optionValue: 'text',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created at',
                                optionValue: 'created_at',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'profile image url',
                                optionValue: 'profile_image_url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'profile background image url',
                                optionValue: 'profile_background_image_url',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Instagram: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'caption',
                                optionValue: 'caption',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'media',
                                optionValue: 'mediaUrl',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'thumbnail',
                                optionValue: 'thumbnailUrl',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'username',
                                optionValue: 'username',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'comments count',
                                optionValue: 'commentsCount',
                                optionType: 'text'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Facebook: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'message',
                                optionValue: 'message',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'full picture',
                                optionValue: 'fullPicture',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.FacebookGroups: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'created',
                                optionValue: 'date',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'comment count',
                                optionValue: 'commentsCount',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'picture',
                                optionValue: 'fullPicture',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'message',
                                optionValue: 'message',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Reddit: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'user name',
                                optionValue: 'name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'screen name',
                                optionValue: 'screen_name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'text',
                                optionValue: 'text',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created at',
                                optionValue: 'created_at',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'profile image url',
                                optionValue: 'profile_image_url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'profile background image url',
                                optionValue: 'profile_background_image_url',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.LinkedIn: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'comment count',
                                optionValue: 'commentCount',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'text',
                                optionValue: 'text',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'post',
                                optionValue: 'post',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'postUrl',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'share count',
                                optionValue: 'shareCount',
                                optionType: 'text'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.TikTok: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'embedUrl',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'caption',
                                optionValue: 'caption',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'thumbnailUrl',
                                optionType: 'html'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.YouTube: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'title',
                                optionValue: 'title',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'thumbnail',
                                optionValue: 'thumbnailUrl',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'page',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Pinterest: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'created',
                                optionValue: 'created',
                                optionType: 'date'
                            },
                            {
                                optionsLabel: 'user name',
                                optionValue: 'username',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'snippet',
                                optionValue: 'postUrl',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'link',
                                optionValue: 'link',
                                optionType: 'html'
                            },
                            {
                                optionsLabel: 'post',
                                optionValue: 'post',
                                optionType: 'text'
                            },
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Telegram: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        ignoreMissingValue: true,
                        options: [
                            {
                                optionsLabel: 'user name',
                                optionValue: 'name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'screen name',
                                optionValue: 'screen_name',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'text',
                                optionValue: 'text',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'created at',
                                optionValue: 'created_at',
                                optionType: 'text'
                            },
                            {
                                optionsLabel: 'profile image url',
                                optionValue: 'profile_image_url',
                                optionType: 'resource'
                            },
                            {
                                optionsLabel: 'profile background image url',
                                optionValue: 'profile_background_image_url',
                                optionType: 'resource'
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        disabled: true,
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }

            // case SceneMimeTypes.NetFeedHoroscope: {
            //     this.uiConfigInit = [
            //         {
            //             type: "select",
            //             label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
            //             name: "fieldName",
            //             value: "",
            //             ignoreMissingValue: true,
            //             options: [
            //                 {
            //                     optionsLabel: 'horoscope',
            //                     optionValue: 'horoscope',
            //                     optionType: 'text'
            //                 },
            //                 {
            //                     optionsLabel: 'sign',
            //                     optionValue: 'sign',
            //                     optionType: 'text'
            //                 }
            //             ],
            //             storePath: 'Data[0].XmlItem[0].$.fieldName'
            //         },
            //         {
            //             type: "select",
            //             label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
            //             name: "fieldType",
            //             disabled: true,
            //             value: "field",
            //             options: ["text"],
            //             storePath: 'Data[0].XmlItem[0].$.fieldType'
            //         }
            //     ];
            //     break;
            // }

            // case SceneMimeTypes.NetFeedNews: {
            //     this.uiConfigInit = [
            //         {
            //             type: "select",
            //             label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
            //             name: "fieldName",
            //             value: "",
            //             ignoreMissingValue: true,
            //             options: [
            //                 {
            //                     optionsLabel: 'title',
            //                     optionValue: 'title',
            //                     optionType: 'text'
            //                 },
            //                 {
            //                     optionsLabel: 'published_date',
            //                     optionValue: 'published_date',
            //                     optionType: 'text'
            //                 },
            //                 {
            //                     optionsLabel: 'source.title',
            //                     optionValue: 'source.title',
            //                     optionType: 'text'
            //                 }
            //             ],
            //             storePath: 'Data[0].XmlItem[0].$.fieldName'
            //         },
            //         {
            //             type: "select",
            //             label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
            //             name: "fieldType",
            //             disabled: true,
            //             value: "field",
            //             options: ["text"],
            //             storePath: 'Data[0].XmlItem[0].$.fieldType'
            //         }
            //     ];
            //     break;
            // }
            case SceneMimeTypes.Weather: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "$[0].data.current_condition[0].iconPath",
                                optionType: "resource",
                                optionsLabel: "current icon"
                            },
                            {
                                optionValue: "$[0].data.current_condition[0].temp_@",
                                optionType: "text",
                                optionsLabel: "current temp"
                            },
                            {
                                optionValue: "$[0].data.current_condition[0].humidity",
                                optionType: "text",
                                optionsLabel: "current humidity"
                            },
                            {
                                optionValue: "$[0].data.weather[0].iconPath",
                                optionType: "resource",
                                optionsLabel: "today icon"
                            },
                            {
                                optionValue: "$[0].data.weather[0].mintemp@",
                                optionType: "text",
                                optionsLabel: "today min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[0].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[0].day",
                                optionType: "text",
                                optionsLabel: "today label"
                            },
                            {
                                optionValue: "$[0].data.weather[1].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+1 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[1].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+1 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[1].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+1 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[1].day",
                                optionType: "text",
                                optionsLabel: "today+1 label"
                            },
                            {
                                optionValue: "$[0].data.weather[2].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+2 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[2].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+2 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[2].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+2 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[2].day",
                                optionType: "text",
                                optionsLabel: "today+2 label"
                            },
                            {
                                optionValue: "$[0].data.weather[3].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+3 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[3].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+3 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[3].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+3 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[3].day",
                                optionType: "text",
                                optionsLabel: "today+3 label"
                            },
                            {
                                optionValue: "$[0].data.weather[4].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+4 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[4].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+4 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[4].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+4 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[4].day",
                                optionType: "text",
                                optionsLabel: "today+4 label"
                            },
                            {
                                optionValue: "$[0].data.weather[5].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+5 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[5].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+5 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[5].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+5 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[5].day",
                                optionType: "text",
                                optionsLabel: "today+5 label"
                            },
                            {
                                optionValue: "$[0].data.weather[6].iconPath",
                                optionType: "resource",
                                optionsLabel: "today+6 icon"
                            },
                            {
                                optionValue: "$[0].data.weather[6].mintemp@",
                                optionType: "text",
                                optionsLabel: "today+6 min temp"
                            },
                            {
                                optionValue: "$[0].data.weather[6].maxtemp@",
                                optionType: "text",
                                optionsLabel: "today+6 max temp"
                            },
                            {
                                optionValue: "$[0].data.weather[6].day",
                                optionType: "text",
                                optionsLabel: "today+6 label"
                            }
                        ],
                        ignoreMissingValue: true,
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Calendar: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "organizer",
                                optionType: "text",
                                optionsLabel: "organizer name"
                            },
                            {
                                optionValue: "startDateTime_time",
                                optionType: "date",
                                optionsLabel: "start date time"
                            },
                            {
                                optionValue: "endDateTime_time",
                                optionType: "date",
                                optionsLabel: "end date time"
                            },
                            {
                                optionValue: "created",
                                optionType: "text",
                                optionsLabel: "created"
                            },
                            {
                                optionValue: "summary",
                                optionType: "text",
                                optionsLabel: "summary"
                            },
                            {
                                optionValue: "description",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "organizerEmail",
                                optionType: "text",
                                optionsLabel: "organizer email"
                            },
                            {
                                optionValue: "updated",
                                optionType: "text",
                                optionsLabel: "updated"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.FacebookWall: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "txt",
                                optionType: "text",
                                optionsLabel: "text"
                            },
                            {
                                optionValue: "pic",
                                optionType: "resource",
                                optionsLabel: "picture"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.FacebookAlbum: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "pic",
                                optionType: "resource",
                                optionsLabel: "pic"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.FacebookVideo: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "desc",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "src",
                                optionType: "resource",
                                optionsLabel: "video"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.EtsyProfile: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "$last_name",
                                optionType: "text",
                                optionsLabel: "$last_name"
                            },
                            {
                                optionValue: "$location",
                                optionType: "text",
                                optionsLabel: "$location"
                            },
                            {
                                optionValue: "$city",
                                optionType: "text",
                                optionsLabel: "$city"
                            },
                            {
                                optionValue: "$bio",
                                optionType: "text",
                                optionsLabel: "$bio"
                            },
                            {
                                optionValue: "$birth_day",
                                optionType: "text",
                                optionsLabel: "$birth_day"
                            },
                            {
                                optionValue: "$birth_month",
                                optionType: "text",
                                optionsLabel: "$birth_month"
                            },
                            {
                                optionValue: "$region",
                                optionType: "text",
                                optionsLabel: "$region"
                            },
                            {
                                optionValue: "$is_seller",
                                optionType: "text",
                                optionsLabel: "$is_seller"
                            },
                            {
                                optionValue: "$materials",
                                optionType: "text",
                                optionsLabel: "$materials"
                            },
                            {
                                optionValue: "$transaction_buy_count",
                                optionType: "text",
                                optionsLabel: "$transaction_buy_count"
                            },
                            {
                                optionValue: "$transaction_sold_count",
                                optionType: "text",
                                optionsLabel: "$transaction_sold_count"
                            },
                            {
                                optionValue: "$image_url_75x75",
                                optionType: "resource",
                                optionsLabel: "$image_url_75x75"
                            }

                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.EtsyListing: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "title",
                                optionType: "text",
                                optionsLabel: "title"
                            },
                            {
                                optionValue: "description",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "quantity",
                                optionType: "text",
                                optionsLabel: "quantity"
                            },
                            {
                                optionValue: "price",
                                optionType: "text",
                                optionsLabel: "price"
                            },
                            {
                                optionValue: "currency_code",
                                optionType: "text",
                                optionsLabel: "currency_code"
                            },
                            {
                                optionValue: "image_medium",
                                optionType: "resource",
                                optionsLabel: "image_medium"
                            },
                            {
                                optionValue: "image_small",
                                optionType: "resource",
                                optionsLabel: "image_small"
                            },
                            {
                                optionValue: "image_full",
                                optionType: "resource",
                                optionsLabel: "image_full"
                            },
                            {
                                optionValue: "image_large",
                                optionType: "resource",
                                optionsLabel: "image_large"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.EtsyShop: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "$story",
                                optionType: "text",
                                optionsLabel: "$story"
                            },
                            {
                                optionValue: "$story_headline",
                                optionType: "text",
                                optionsLabel: "$story_headline"
                            },
                            {
                                optionValue: "$story_leading_paragraph",
                                optionType: "text",
                                optionsLabel: "$story_leading_paragraph"
                            },
                            {
                                optionValue: "$status",
                                optionType: "text",
                                optionsLabel: "$status"
                            },
                            {
                                optionValue: "currency_code",
                                optionType: "text",
                                optionsLabel: "currency_code"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.FiveHundredUser:
            case SceneMimeTypes.FiveHundredCollection: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "name",
                                optionType: "text",
                                optionsLabel: "name"
                            },
                            {
                                optionValue: "description",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "image_url",
                                optionType: "resource",
                                optionsLabel: "image"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.YelpReviews: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "user.name",
                                optionType: "text",
                                optionsLabel: "user.name"
                            },
                            {
                                optionValue: "rating",
                                optionType: "text",
                                optionsLabel: "rating"
                            },
                            {
                                optionValue: "excerpt",
                                optionType: "text",
                                optionsLabel: "excerpt"
                            },
                            {
                                optionValue: "time_created",
                                optionType: "date",
                                optionsLabel: "time_created"
                            },
                            {
                                optionValue: "rating_image_url",
                                optionType: "resource",
                                optionsLabel: "rating_image_url"
                            },
                            {
                                optionValue: "rating_image_small_url",
                                optionType: "resource",
                                optionsLabel: "rating_image_small_url"
                            },
                            {
                                optionValue: "user.image_url",
                                optionType: "resource",
                                optionsLabel: "user.image_url"
                            },
                            {
                                optionValue: "rating_image_large_url",
                                optionType: "resource",
                                optionsLabel: "rating_image_large_url"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "date", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.YelpInfo: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "title",
                                optionType: "text",
                                optionsLabel: "title"
                            },
                            {
                                optionValue: "$name",
                                optionType: "text",
                                optionsLabel: "name"
                            },
                            {
                                optionValue: "$rating",
                                optionType: "text",
                                optionsLabel: "rating"
                            },
                            {
                                optionValue: "$snippet_text",
                                optionType: "text",
                                optionsLabel: "snippet text"
                            },
                            {
                                optionValue: "$phone",
                                optionType: "text",
                                optionsLabel: "phone"
                            },
                            {
                                optionValue: "$rating_img_url_small",
                                optionType: "resource",
                                optionsLabel: "rating img url small"
                            },
                            {
                                optionValue: "$rating_img_url_large",
                                optionType: "resource",
                                optionsLabel: "rating img url large"
                            },
                            {
                                optionValue: "$snippet_image_url",
                                optionType: "resource",
                                optionsLabel: "snippet image url"
                            },
                            {
                                optionValue: "$image_url",
                                optionType: "resource",
                                optionsLabel: "image url"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.PinterestUser: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "boardThumb",
                                optionType: "resource",
                                optionsLabel: "thumb"
                            },
                            {
                                optionValue: "boardName",
                                optionType: "text",
                                optionsLabel: "name"
                            },
                            {
                                optionValue: "src",
                                optionType: "resource",
                                optionsLabel: "image"
                            },
                            {
                                optionValue: "description",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "likes",
                                optionType: "text",
                                optionsLabel: "likes"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName',
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.PinterestBoard: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "likes",
                                optionType: "text",
                                optionsLabel: "likes"
                            },
                            {
                                optionValue: "description",
                                optionType: "text",
                                optionsLabel: "description"
                            },
                            {
                                optionValue: "src",
                                optionType: "resource",
                                optionsLabel: "image"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.TumblrPhotos: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "date_time",
                                optionType: "date",
                                optionsLabel: "date"
                            },
                            {
                                optionValue: "slug",
                                optionType: "text",
                                optionsLabel: "slug"
                            },
                            {
                                optionValue: "body",
                                optionType: "text",
                                optionsLabel: "body"
                            },
                            {
                                optionValue: "photo_url",
                                optionType: "resource",
                                optionsLabel: "image"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "date", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.TumblrVideos: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "date_time",
                                optionType: "date",
                                optionsLabel: "date"
                            },
                            {
                                optionValue: "slug",
                                optionType: "text",
                                optionsLabel: "slug"
                            },
                            {
                                optionValue: "body",
                                optionType: "text",
                                optionsLabel: "body"
                            },
                            {
                                optionValue: "video_url",
                                optionType: "resource",
                                optionsLabel: "video"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.TumblrPosts:
            case SceneMimeTypes.TumblrTexts: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "date_time",
                                optionType: "date",
                                optionsLabel: "date"
                            },
                            {
                                optionValue: "slug",
                                optionType: "text",
                                optionsLabel: "slug"
                            },
                            {
                                optionValue: "body",
                                optionType: "text",
                                optionsLabel: "body"
                            },
                            {
                                optionValue: "title",
                                optionType: "text",
                                optionsLabel: "title"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.InstagramFeed: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "title",
                                optionType: "text",
                                optionsLabel: "title"
                            },
                            {
                                optionValue: "video",
                                optionType: "resource",
                                optionsLabel: "video"
                            },
                            {
                                optionValue: "urlImage",
                                optionType: "resource",
                                optionsLabel: "image"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.InstagramMedia: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        ignoreMissingValue: true,
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        name: "fieldName",
                        value: "",
                        options: [
                            {
                                optionValue: "title",
                                optionType: "text",
                                optionsLabel: "title"
                            },
                            {
                                optionValue: "video",
                                optionType: "resource",
                                optionsLabel: "video"
                            },
                            {
                                optionValue: "urlImage",
                                optionType: "resource",
                                optionsLabel: "image"
                            }
                        ],
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    },
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        disabled: true,
                        options: ["text", "resource"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    }
                ];
                break;
            }
            case SceneMimeTypes.Player: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "fieldName",
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    }
                ];
                // this.uiConfigInit = [
                //     {
                //         type: "input",
                //         inputType: "text",
                //         label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                //         name: "fieldType",
                //         value: "field",
                //         storePath: 'Data[0].XmlItem[0].$.fieldType'
                //     }
                //     // ,
                //     // {
                //     //     type: "input",
                //     //     value: '',
                //     //     label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                //     //     inputType: "text",
                //     //     name: "fieldName",
                //     //     storePath: 'Data[0].XmlItem[0].$.fieldName'
                //     // }
                // ];
                break;
            }
            default: {
                this.uiConfigInit = [
                    {
                        type: "select",
                        label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                        name: "fieldType",
                        value: "field",
                        options: ["text", "date", "resource", "object"],
                        storePath: 'Data[0].XmlItem[0].$.fieldType'
                    },
                    {
                        type: "input",
                        value: '',
                        label: this.translocoService.translate('general.name', {}, this.translocoService.getActiveLang()),
                        inputType: "text",
                        name: "fieldName",
                        storePath: 'Data[0].XmlItem[0].$.fieldName'
                    }
                ];
            }
        }
        this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }

    // initMimeType() {
    //     this.cancelOnDestroy(
    //         this.storeSelector.getScene(this.sceneId)
    //             .pipe(take(1))
    //             .subscribe((i_scene) => {
    //                 this.mimeType = i_scene.Player.$.mimeType;
    //             })
    //     );
    // }

    override submit(formValues) {
        formValues = this.checkDisabled(formValues);
        switch (this.mimeTypeLong) {
            case SceneMimeTypes.Spreadsheet: {
                formValues.fieldName = `$cells.${formValues.fieldName}.${formValues.fieldName2}.value`;
                delete formValues['fieldName2'];
                return super.submit(formValues);
            }
            default: {
                return super.submit(formValues);
            }
        }
    }

    override initApplyStoreToDynamic(v) {
        super.initApplyStoreToDynamic(v);
    }

    /**
     * @private checkDisabled
     * check if using a configuration of <SELECT> that depends on another <SELECT> and the 2nd select is always disabled
     * as we are using Json weather and Json drive
     */
    private checkDisabled(i_formValues) {
        const disabled = this.uiConfigInit.findIndex((v) => v.disabled && v.disabled === true);
        if (i_formValues.fieldName && !i_formValues.fieldType && disabled > -1) {
            this.uiConfigInit.forEach((v) => {
                if (v.name === 'fieldName') {
                    const opt = v.options.find((m) => m.optionValue === i_formValues.fieldName);
                    if (opt) {
                        i_formValues.fieldType = opt.optionType;
                    }
                }
            });
        }
        return i_formValues;
    }

    override componentInit() {
        super.componentInit();
    }

    switchFieldType(i_fieldType) {
        if (_.isUndefined(i_fieldType)) {
            return this.toastr.error(this.translocoService.translate('toast.sorryCantFindComponent', {}, this.translocoService.getActiveLang()));
        }
        this.fieldType = i_fieldType;
        switch (i_fieldType.toLowerCase()) {
            case 'date': {
                const dateFormat = this.sceneItem?.Data?.[0]?.XmlItem?.[0]?.$?.dateFormat;
                if (!dateFormat) this.dispatchField('dateFormat', 'DD/MM/YY');
                break;
            }
            case 'name':
            case 'itemname':
            case 'iteminfo0':
            case 'iteminfo1':
            case 'iteminfo2':
            case 'iteminfo3':
            case 'title':
            case 'description':
            case 'text': {
                const fontFormat: IFontFormat = {
                    fontSize: '16',
                    fontColor: '26214',
                    fontFamily: 'Arial',
                    fontWeight: 'bold',
                    fontStyle: 'italic',
                    textDecoration: 'underline',
                    textAlign: 'left',
                    alignSelf: 'center',
                    autoScaling: '1',
                    wrap: '1'
                };
                switch (this.mimeTypeLong) {
                    case SceneMimeTypes.Catalog: {
                        const fontSnippet = this.sceneItem.Data[0].CatalogItem[0].Font[0];
                        if (!fontSnippet) this.onFontChanged(fontFormat, '', 'CatalogItem', true);
                        break;
                    }
                    case SceneMimeTypes.CustomRss: {
                        const fontSnippet = this.sceneItem.Data[0].RssItem[0].Font[0];
                        if (!fontSnippet) this.onFontChanged(fontFormat, '', 'RssItem', true);
                        break;
                    }
                    default: {
                        const fontSnippet = this.sceneItem?.Data?.[0]?.XmlItem?.[0]?.Font;
                        if (!fontSnippet) this.onFontChanged(fontFormat, '', 'XmlItem', true);
                        break;
                    }
                }
                break;
            }
            case 'object':
            case 'resource':
            case 'itemresourcemain': {
                const maintainAspectRatio = this.getMaintainAspectRatio();
                if (!maintainAspectRatio) this.dispatchField('maintainAspectRatio', '1', this.getStorePath());
                break;
            }
        }
    }

    private dispatchField(key, value, storePath = 'Data[0].XmlItem[0].$') {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key,
                value,
                storePath,
            }]
        });
    }

    getStorePath(): string {
        switch (this.mimeTypeShort) {
            case 'CustomRss': {
                return 'Data[0].RssItem[0].$';
            }
            default: {
                return 'Data[0].XmlItem[0].$';
            }
        }
    }

    getMaintainAspectRatio(): string {
        let maintainAspectRatio = '1';
        switch (this.mimeTypeShort) {
            case 'CustomRss': {
                maintainAspectRatio = this.sceneItem?.Data?.[0]?.RssItem?.[0]?.$?.maintainAspectRatio;
                break;
            }
            default: {
                maintainAspectRatio = this.sceneItem?.Data?.[0]?.XmlItem?.[0]?.$?.maintainAspectRatio;
            }
        }
        return maintainAspectRatio;
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        let fieldType = this.sceneItem.Data?.[0]?.XmlItem?.[0]?.$?.fieldType;
        this.dateModel = this.sceneItem.Data?.[0]?.XmlItem?.[0]?.$?.dateFormat;

        const maintainAspectRatio = this.getMaintainAspectRatio();
        this.maintainAspectRatio = maintainAspectRatio === '1';

        fieldType = this.handleMimeAnomalies(fieldType);
        this.switchFieldType(fieldType);

        switch (this.mimeTypeLong) {
            case SceneMimeTypes.Stocks: {
                break;
            }
            case SceneMimeTypes.XML: {
                break;
            }
            case SceneMimeTypes.CustomRss: {
                break;
            }
            case SceneMimeTypes.Catalog: {
                break;
            }
            case SceneMimeTypes.Spreadsheet: {
                const fieldName = this.sceneItem.Data?.[0]?.XmlItem?.[0]?.$?.fieldName;
                const re = fieldName.match(/([0-9]+).([0-9]+)/);
                const val = re ? re : ['', '', ''];
                this.setFormValue('fieldName', val[1]);
                this.setFormValue('fieldName2', val[2]);
                break;
            }
            default: {
                this.setFormValue('fieldType', fieldType);
            }
        }
    }

    private handleMimeAnomalies(fieldType) {
        if (fieldType) return fieldType;
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.JSONITEM.id: {
                return this.sceneItem.Data?.[0]?.XmlItem?.[0]?.$?.fieldName;
            }
            case this.blockLabelRecords.STOCKS_ITEM.id: {
                return this.sceneItem.Data?.[0]?.StockItem?.[0]?.$?.field;
            }
            case this.blockLabelRecords.XML_ITEM.id: {
                return this.sceneItem.Data?.[0]?.XmlItem?.[0]?.$?.fieldType;
            }
            case this.blockLabelRecords.CUSTOMRSS_ITEM.id: {
                return this.sceneItem.Data?.[0]?.RssItem?.[0]?.$?.field;
            }
            case this.blockLabelRecords.CATALOG_ITEM.id: {
                return this.sceneItem.Data?.[0]?.CatalogItem?.[0]?.$?.field;
            }
        }
    }

    private checkOtherTypes(fieldType) {
    }

    onDateChanged() {
        this.dispatchField('dateFormat', this.dateModel);
    }

    toggleAspectRatio() {
        this.maintainAspectRatio = !this.maintainAspectRatio;
        this.dispatchField('maintainAspectRatio', this.maintainAspectRatio ? '1' : '0', this.getStorePath());
    }
}
